/**
 * Phase 0 · Infra-1 — web build stub for useAgoraCall.
 *
 * `react-native-agora` is native-only, so the real implementation cannot be
 * bundled for web. Metro picks `.web.ts` over `.ts` for the web target, so
 * any import of `useAgoraCall` from web code resolves to this inert stub.
 *
 * Web sponsors use the standalone client at `public/meet.html` instead.
 */

export interface AgoraCallCredentials {
  appId: string;
  token: string;
  channel: string;
  uid: number;
}

export interface RemoteUser {
  uid: number;
  hasVideo: boolean;
  hasAudio: boolean;
}

export type CallPhase =
  | 'idle'
  | 'connecting'
  | 'connected'
  | 'reconnecting'
  | 'ended'
  | 'failed';

export interface AgoraCallState {
  phase: CallPhase;
  error: string | null;
  localUid: number | null;
  remoteUsers: RemoteUser[];
  micEnabled: boolean;
  cameraEnabled: boolean;
  previewLocal: (params: { appId: string; video?: boolean }) => void;
  join: (
    creds: AgoraCallCredentials,
    options?: { video?: boolean; initialMicMuted?: boolean; initialCamOff?: boolean }
  ) => Promise<void>;
  leave: () => Promise<void>;
  toggleMic: () => void;
  toggleCamera: () => void;
  switchCamera: () => void;
}

const noop = () => {};
const asyncNoop = async () => {};

export function useAgoraCall(): AgoraCallState {
  return {
    phase: 'idle',
    error: 'Videochamadas não estão disponíveis no navegador. Abra o aplicativo no celular.',
    localUid: null,
    remoteUsers: [],
    micEnabled: false,
    cameraEnabled: false,
    previewLocal: noop,
    join: asyncNoop,
    leave: asyncNoop,
    toggleMic: noop,
    toggleCamera: noop,
    switchCamera: noop,
  };
}
